/* The cart remains Shopify-owned. No localStorage, product price overrides or duplicate cart creation. Displayed delivery fee is an estimate; Shopify owns checkout rates. */
(() => {
  const config = window.skyCartUXConfig || {};
  const t = config.strings || {};
  const isVisible = rect => rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  let toast;
  const toastStateKey = 'sky-cart-pending-notice';
  let positionFrame = 0;
  function positionToast() {
    positionFrame = 0;
    if (!toast?.classList.contains('is-visible')) return;
    const header = document.getElementById('shopify-section-header');
    const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    toast.style.setProperty('--sky-cart-notice-top', `${Math.min(bottom, innerHeight * .4) + 8}px`);
  }
  function schedulePosition() {
    if (!positionFrame) positionFrame = requestAnimationFrame(positionToast);
  }
  function rememberToast(visible) {
    try {
      if (visible) sessionStorage.setItem(toastStateKey, '1');
      else sessionStorage.removeItem(toastStateKey);
    } catch (_) { /* The notice still works when browser storage is unavailable. */ }
  }
  function dismissToast() {
    toast?.classList.remove('is-visible');
    rememberToast(false);
  }
  function showToast() {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'sky-cart-toast';
      const status = document.createElement('span'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.dataset.message = '';
      const button = document.createElement('button'); button.type = 'button'; button.textContent = t.viewCart;
      button.addEventListener('click', () => { dismissToast(); const drawer = document.querySelector('cart-drawer'); if (drawer) drawer.open(document.querySelector('#cart-icon-bubble')); else location.assign(window.routes.cart_url); });
      toast.append(status, button); document.body.append(toast);
      const header = document.getElementById('shopify-section-header');
      if (header && window.ResizeObserver) new ResizeObserver(schedulePosition).observe(header);
    }
    toast.querySelector('[data-message]').textContent = '';
    requestAnimationFrame(() => { toast.querySelector('[data-message]').textContent = t.added; });
    toast.classList.add('is-visible');
    positionToast();
    rememberToast(true);
    return toast;
  }
  function restoreToast() {
    if (!config.fly || Number(config.itemCount) === 0) { dismissToast(); return; }
    try {
      if (sessionStorage.getItem(toastStateKey) === '1') showToast();
      else toast?.classList.remove('is-visible');
    } catch (_) { /* Retain the current in-page notice when storage is blocked. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreToast, {once:true});
  else restoreToast();
  window.addEventListener('pageshow', event => { if (event.persisted) restoreToast(); });
  window.addEventListener('scroll', schedulePosition, {passive:true});
  window.addEventListener('resize', schedulePosition, {passive:true});
  document.addEventListener('sky:cart-opened', dismissToast);
  function flyProduct(source, product, fallbackTarget) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !Element.prototype.animate) return null;
      const icon = document.querySelector('#cart-icon-bubble');
      const target = icon && isVisible(icon.getBoundingClientRect()) ? icon : fallbackTarget;
      if (!target) return null;
      const end = target.getBoundingClientRect();
      const start = source?.rect;
      const src = source?.src || product?.featured_image?.url || product?.image;
      if (!src || !start || !isVisible(start)) return null;
      const img = document.createElement('img'); img.className = 'sky-cart-flying-image'; img.alt = ''; img.setAttribute('aria-hidden', 'true'); img.src = src;
      const size = Math.max(40, Math.min(96, start.width, start.height));
      const x = Math.max(0,Math.min(innerWidth-size,start.left+start.width/2-size/2));
      const y = Math.max(0,Math.min(innerHeight-size,start.top+start.height/2-size/2));
      Object.assign(img.style,{left:`${x}px`,top:`${y}px`,width:`${size}px`,height:`${size}px`}); document.body.append(img);
      const dx=end.left+end.width/2-x-size/2, dy=end.top+end.height/2-y-size/2;
      const duration = 900;
      const animation=img.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*.4}px,${Math.min(-60,dy*.6)}px) scale(.8)`,opacity:1,offset:.45},{transform:`translate(${dx*.99}px,${dy*.99}px) scale(.16)`,opacity:1,offset:.99},{transform:`translate(${dx}px,${dy}px) scale(.12)`,opacity:0}],{duration,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});
      const cleanup = setTimeout(()=>img.remove(),duration + 400);
      animation.finished.catch(()=>{}).finally(()=>{clearTimeout(cleanup);img.remove();});
      return {cancel(){clearTimeout(cleanup);animation.cancel();img.remove();}};
  }
  window.skyCartExperience = {
    enabled: Boolean(config.fly),
    capture(form) {
      const scope = form.closest('.sky-card, [data-sky-product], .card-wrapper, .sg-product, .product, quick-add-modal, .shopify-section') || form;
      const candidates = [...scope.querySelectorAll('.product__media-item.is-active img, .card__media img, .product__media img, img')];
      const visibleImage = candidates.find(el => isVisible(el.getBoundingClientRect()));
      const img = visibleImage || candidates[0];
      const fallback = form.querySelector('[type="submit"]');
      const rect = (visibleImage || fallback)?.getBoundingClientRect();
      return rect ? {src:img?.currentSrc || img?.src,rect:{left:rect.left,top:rect.top,width:rect.width,height:rect.height,bottom:rect.bottom,right:rect.right}} : null;
    },
    start(source) { return config.fly ? flyProduct(source) : null; },
    confirm(source, product, pendingFlight) {
      config.itemCount = Math.max(1, Number(config.itemCount) || 0);
      const notice = showToast();
      if (!pendingFlight) flyProduct(source, product, notice.querySelector('button'));
    }
  };
  document.addEventListener('sky:cart-updated', event => {
    if (Number.isFinite(event.detail?.item_count)) {
      config.itemCount = event.detail.item_count;
      if (event.detail.item_count === 0) dismissToast();
    }
  });
})();
